import { Editor } from '../Editor'

export const InputText = (props) => {
  return <Editor height={320} {...props} />
}
